import { EuiSpacer } from '@elastic/eui';
import PTZTourTable from 'components/Web_User_Interface/720p_Series/System/PTZ_Tour/ptzTourTable';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  EuiSpacer,
  PTZTourTable,
  BreadCrumbs,
  SEOHelmet,
  React
};